import React from 'react';

import {
  ChevronLeft as BaseChevronLeftIcon,
  ChevronRight as BaseChevronRightIcon,
  Circle as BaseCircleIcon,
  CircleOutlined as BaseCircleOutlinedIcon
} from '@mui/icons-material';
import {
  Box,
  IconButton as MuiIconButton,
  styled
} from '@mui/material';
import _ from 'lodash';
import { imageUtil } from 'modules';



const RootContainerBox = styled(Box)({
  display: 'flex',
  flexDirection: 'row'
});

const ChevronLeftIcon = styled(BaseChevronLeftIcon)({
  color: '#FFFFFF',
  fontSize: 60
});

const ChevronRightIcon = styled(BaseChevronRightIcon)({
  color: '#FFFFFF',
  fontSize: 60
});

const CircleIcon = styled(BaseCircleIcon)({
  color: '#FFFFFF'
});

const CircleOutlinedIcon = styled(BaseCircleOutlinedIcon)({
  color: '#FFFFFF'
});

const NavigationDots = styled(Box)({
  display: 'flex',
  width: '100%',
  justifyContent: 'center',
  marginTop: 20,
  gap: 15
});



const CarouselImage = styled('img')(({ theme }) => ({
  borderRadius: theme.shape.borderRadius,
  width: '100%'
}));

const IconButton = styled(MuiIconButton)(({ theme }) => ({
  paddingLeft: 0,
  paddingRight: 0,
  borderRadius: 0
}));



interface IProps {
  imageUrls: string[];
}

export const FC: React.FC<IProps> = props => {
  const imgUrls = _.map(props.imageUrls, url => imageUtil.getUrlFromFilename(url));

  const [curIndex, setCutIndex] = React.useState(0);

  const slideCounts = React.useMemo(() => (
    imgUrls.length
  ), [imgUrls.length]);

  const dots = React.useMemo(() => (
    Array(slideCounts).fill(0).map((_, i) => <CircleOutlinedIcon key={i}/>)
  ), [slideCounts]);



  const __renderDots = React.useCallback(() => {
    const activeDots = [...dots];
    activeDots[curIndex] = <CircleIcon key={curIndex} />;
    return activeDots;
  }, [curIndex, dots]);



  return (
    <RootContainerBox>
      <IconButton
        onClick={() => setCutIndex((curIndex - 1 + slideCounts) % slideCounts)}>
        <ChevronLeftIcon />
      </IconButton>

      <Box>
        {imgUrls.map((url, index) => (
          <CarouselImage
            key={url}
            style={{ display: index === curIndex ? 'block' : 'none' }}
            alt={url}
            src={url} />
        ))}

        <NavigationDots>
          {__renderDots()}
        </NavigationDots>
      </Box>

      <IconButton onClick={() => setCutIndex((curIndex + 1) % slideCounts)}>
        <ChevronRightIcon />
      </IconButton>
    </RootContainerBox>
  );
};
